package com.flowyride.core.domain.model

/** A geocoded location the rider can pick as a waypoint. */
data class Place(
    /** Short name, e.g. "Annecy". */
    val name: String,
    /** Context used to disambiguate, e.g. "Haute-Savoie, France". */
    val detail: String?,
    val point: GeoPoint,
)
